import { RichText } from "@components/cms/rich-text-renderer/RichText";
import { Box } from "@ecco/ui/box";
import { isEmpty } from "lodash-es";
import { checkoutSupportModuleStyles } from "./CheckoutStyles";
import type { IModuleCardGeneric, IModuleText } from "@contentful-api/types/contentful";

export default function SupportModuleBox({
    supportModule,
    display,
    p,
    mt = 0,
}: {
    supportModule: IModuleCardGeneric | IModuleText;
    display: string[];
    p: number;
    mt?: number;
}) {
    if (isEmpty(supportModule)) return null;

    return (
        <Box background="white" display={display} p={p} mt={mt} sx={checkoutSupportModuleStyles}>
            <RichText data={supportModule.fields.text} />
        </Box>
    );
}
